import { render } from "./ITDesarrolloDeSoftware.vue?vue&type=template&id=6dc68e49&scoped=true"
import script from "./ITDesarrolloDeSoftware.vue?vue&type=script&lang=js"
export * from "./ITDesarrolloDeSoftware.vue?vue&type=script&lang=js"

import "./ITDesarrolloDeSoftware.vue?vue&type=style&index=0&id=6dc68e49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc68e49"]])

export default __exports__